'use client';

import { c as _c } from "react/compiler-runtime";
import skillsData from '@/data/skills.json';
import { ProfileSection, ExperienceSection, ProjectsSection, Footer } from '@/components/features';
import { Mode, ModeConfig } from '@/components/shared/types';
import PMTransition from '@/components/shared/PMTransition';
interface ProductManagerPerspectiveProps {
  activeMode: Mode;
  design: ModeConfig['design'];
  isDark: boolean;
  copied: boolean;
  onCopyEmail: () => void;
}
export default function ProductManagerPerspective(t0) {
  const $ = _c(31);
  const {
    activeMode,
    design,
    isDark,
    copied,
    onCopyEmail
  } = t0;
  let t1;
  if ($[0] !== activeMode) {
    t1 = skillsData[activeMode as keyof typeof skillsData] || [];
    $[0] = activeMode;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentSkills = t1;
  const fontClass = design.fontFamily === "mono" ? "font-mono" : "font-sans";
  const t2 = `min-h-screen transition-all duration-500 ease-in-out ${design.theme} ${fontClass} relative`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="fixed inset-0 grid-pattern-pm pointer-events-none z-0" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = activeMode === "pm";
  let t5;
  if ($[3] !== activeMode || $[4] !== copied || $[5] !== currentSkills || $[6] !== design || $[7] !== isDark || $[8] !== onCopyEmail) {
    t5 = <ProfileSection activeMode={activeMode} design={design} isDark={isDark} copied={copied} onCopyEmail={onCopyEmail} skills={currentSkills} />;
    $[3] = activeMode;
    $[4] = copied;
    $[5] = currentSkills;
    $[6] = design;
    $[7] = isDark;
    $[8] = onCopyEmail;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] !== activeMode || $[11] !== design || $[12] !== isDark) {
    t6 = <ExperienceSection activeMode={activeMode} design={design} isDark={isDark} />;
    t7 = <ProjectsSection activeMode={activeMode} design={design} isDark={isDark} />;
    $[10] = activeMode;
    $[11] = design;
    $[12] = isDark;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[15] !== activeMode || $[16] !== design) {
    t8 = <Footer design={design} activeMode={activeMode} />;
    $[15] = activeMode;
    $[16] = design;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <main className="lg:col-span-7 space-y-24 mt-16 lg:mt-0">{t6}{t7}{t8}</main>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t5 || $[23] !== t9) {
    t10 = <div className="relative z-10"><div className="mx-auto max-w-[1800px] px-6 py-12 lg:px-12 lg:py-16"><div className="lg:grid lg:grid-cols-12 lg:gap-16">{t5}{t9}</div></div></div>;
    $[22] = t5;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t4) {
    t11 = <PMTransition isActive={t4}>{t10}</PMTransition>;
    $[25] = t10;
    $[26] = t4;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t2) {
    t12 = <div className={t2}>{t3}{t11}</div>;
    $[28] = t11;
    $[29] = t2;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}